import React from "react";
import "./App.scss";
import Navbar from "./components/Navbar/Navbar";
import Stories from "./components/Stories/Stories";
import Share from "./components/Share/Share";
import Post from "./components/Post/Post";

function App() {
  return (
    <div className="app">
      <Navbar />
      <Stories />
      <Share />
      <Post
        name="Usuario 1"
        time="1 min"
        url="https://picsum.photos/600/350"
        content="Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum "
      />
      <Post
        name="Usuario 2"
        time="5 min"
        url="https://picsum.photos/601/351"
        content="Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum "
      />
      <Post
        name="Usuario 3"
        time="15 min"
        url=""
        content="Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsumLorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum. (No image)"
      />
      <Post
        name="Usuario 4"
        time="30 min"
        url="https://picsum.photos/603/353"
        content="Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum "
      />
    </div>
  );
}

export default App;
